<app-dpp-field-label [label]="property.idShort | translateOrFallback:(property.idShort ?? '')"></app-dpp-field-label>
<ix-input
  [formControl]="formControl"
  class="w-100"
  [id]="'field_' + property.idShort"
/>
